module.exports = __webpack_public_path__ + "img/gift-14.f0f78c7f.jpg";